/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable comma-style */
/* eslint-disable no-undef */
import { BoltiveLoader } from './boltiveLoader';

const props = [];

export const BoltiveLoaderDirective = (reactDirective) => reactDirective(BoltiveLoader, props);
BoltiveLoaderDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('boltiveLoader', BoltiveLoaderDirective);
